module.exports = __webpack_public_path__ + "static/media/kor_4.9f88dc5d.jpg";